import React from 'react';
import { Pagination } from 'antd';
import styles from './styles.module.scss';

interface PaginationProps {
  setPageNumber: any;
  total: number;
  pageSize: number;
  pageNumber: number;
}
const PaginationComponent: React.FC<PaginationProps> = ({
  setPageNumber,
  total,
  pageSize,
  pageNumber,
}: PaginationProps) => (
  <>
    <Pagination
      className={styles.pagination}
      total={total}
      defaultPageSize={pageSize}
      current={pageNumber}
      defaultCurrent={1}
      showSizeChanger={false}
      size="small"
      onChange={(page, pageSize) => {
        setPageNumber(page);
      }}
    />
  </>
);

export default PaginationComponent;
